import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import DatePresenter from '../../../../../../presenters/DatePresenter';
import { STATES } from '../../../../../../presenters/SupportRequestPresenter';
import Flash from '../../../../../../components/forms/Flash';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import RangePicker from '../../../../../../components/RangePicker';

const Form = (props) => {
  const { values, handleSubmit, setFieldValue, errors } = props;

  const handleChange = ({ target: { id, value } }) => {
    setFieldValue(id, value);
  };

  const handleStartDateChange = (date) => {
    setFieldValue('createdAfter', DatePresenter.shortFormattedDate(date));
  };
  const handleEndDateChange = (date) => {
    setFieldValue('createdBefore', DatePresenter.shortFormattedDate(date));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="support-requests-filters">
        <div className="form-header">
          <h4>Filters</h4>
          <div className="form-header-actions">
            <input id="findSupportRequests" type="submit" defaultValue="Find" />
          </div>
        </div>
        {!isNil(errors) && <Flash response={errors} />}
        <Row className="support-requests-filters">
          <RangePicker
            startDate={values.createdAfter}
            endDate={values.createdBefore}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
          />
          <Column>
            <input
              type="text"
              id="byUser"
              placeholder="Auth0 id or email"
              value={values.byUser}
              onChange={handleChange}
              className="input-underlined"
            />
          </Column>
          <Column>
            <select
              id="byState"
              value={values.byState}
              onChange={handleChange}
              className="input-underlined"
            >
              <option value={STATES.all}>All</option>
              <option value={STATES.open}>Open</option>
              <option value={STATES.pending}>Pending</option>
              <option value={STATES.closed}>Closed</option>
            </select>
          </Column>
        </Row>
      </div>
    </form>
  );
};

export default Form;

Form.propTypes = {
  values: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

Form.defaultProps = {
  errors: {},
};
